
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Report_Adv04Dialog extends Serenity.EntityDialog<Report_Adv04Row, any> {
        protected getFormKey() { return Report_Adv04Form.formKey; }
        protected getIdProperty() { return Report_Adv04Row.idProperty; }
        protected getLocalTextPrefix() { return Report_Adv04Row.localTextPrefix; }
        protected getNameProperty() { return Report_Adv04Row.nameProperty; }
        protected getService() { return Report_Adv04Service.baseUrl; }
        protected getDeletePermission() { return Report_Adv04Row.deletePermission; }
        protected getInsertPermission() { return Report_Adv04Row.insertPermission; }
        protected getUpdatePermission() { return Report_Adv04Row.updatePermission; }

        protected form = new Report_Adv04Form(this.idPrefix);

    }
}